import logger from '@logger'
import { getProductInfos } from '@tracking'

export const logDesync = ({
  $store,
  $route,
  legacyId,
  isOutOfStock,
  price,
  ratings,
}) => {
  const {
    price: storedPrice,
    reviewRating: storedRatings,
    source,
  } = getProductInfos(legacyId)
  const country = $store.getters['config/country']

  // When opening a link in a new tab or window, a new session storage instance is created.
  // In our case, the product thumbnail price will not be found. It means that we can't
  // properly know wether prices are desync or not, so we skip the monitoring step.
  // See: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API
  if (storedPrice === undefined || source === undefined) {
    return
  }

  const cardPrice = Number(storedPrice)
  const productPrice = Number(price)

  if (cardPrice !== productPrice) {
    logger.info('[S&R][Error][ProductPage] Price desync detected', {
      id: $route.params.uuid,
      cardPrice,
      productPrice,
      country,
      source,
    })
  }

  if (isOutOfStock) {
    logger.info('[S&R][Error][ProductPage] Stock desync detected', {
      id: $route.params.uuid,
      country,
      source,
    })
  }

  if (
    ratings?.averageRate !== storedRatings?.average ||
    ratings?.reviewsCount !== storedRatings?.count
  ) {
    logger.info('[S&R][Error][ProductPage] Review Rating desync detected', {
      id: $route.params.uuid,
      country,
      source,
      cardReviewRating: {
        average: storedRatings?.average,
        count: storedRatings?.count,
      },
      productReviewRating: {
        average: ratings.averageRate,
        count: ratings.reviewsCount,
      },
    })
  }
}
